import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Work from './pages/Work';
import About from './pages/About';
import Sketches from './pages/Sketches';
import Project from './pages/Project';
import { Route, Routes } from 'react-router-dom';
import { useState, useEffect } from 'react';

const App = () => {
  const [userdata, setUserData] = useState({work: {}, resume: {}, toolbar: {}, sketches: {}})
  useEffect(() => {
    const loadFavIcon = async () => {
      // let link = document.querySelector("link[rel~='icon']");
      // if (!link) {
      //   link = document.createElement('link');
      //   link.rel = 'icon';
      //   document.head.appendChild(link);
      // }

      await fetch(`${process.env.PUBLIC_URL}/userdata/userdata.json`, {headers: {"Content-Type": "application/json"} }).then((d) => {return d.json()}).then( (d) => setUserData(d) );
      // const data = await fetch(`userdata/favicon/${userdata.toolbar.favicon}`);
      // link.href = data.default;
      
    }

    loadFavIcon()
  }, [])

  return (
    <div className='App'>
      <Navbar toolbarinfo={userdata.toolbar} resumeInfo={userdata.resume} />
      <Routes>
        <Route path='/' >
          <Route index element={<Work projects={userdata.work} />} />
          <Route path=':projname' element={<Project />} />
        </Route>
        <Route path='/about' element={<About aboutinfo={userdata.about} resumeInfo={userdata.resume} />} />
      <Route path='/renders' element={<Sketches sketches={userdata.sketches} />} />
      </Routes>
    </div>
  );
}

export default App;
